const KEY = "parking_escape_highscore_v1";

export function getHighScore() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { outdoor: 0, underground: 0 };
    const p = JSON.parse(raw);
    return { outdoor: p.outdoor || 0, underground: p.underground || 0 };
  } catch (e) {
    return { outdoor: 0, underground: 0 };
  }
}

export function setHighScore(level, score) {
  const cur = getHighScore();
  if (score > (cur[level] || 0)) {
    cur[level] = score;
    localStorage.setItem(KEY, JSON.stringify(cur));
    return true;
  }
  return false;
}

const NAME_KEY = "parking_escape_player_name";
export function getPlayerName() {
  return localStorage.getItem(NAME_KEY) || "";
}
export function setPlayerName(name) {
  localStorage.setItem(NAME_KEY, name.trim().slice(0, 20));
}
